module.exports = __webpack_public_path__ + "img/economia_customizado.6d8e3854.png";